import { render } from "./Proposta.vue?vue&type=template&id=136a33e2&scoped=true"
import script from "./Proposta.vue?vue&type=script&lang=js"
export * from "./Proposta.vue?vue&type=script&lang=js"

import "./Proposta.vue?vue&type=style&index=0&id=136a33e2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-136a33e2"]])

export default __exports__